import { RESULT_TYPE } from '@savgroup-front-common/types';

export const INITIAL_SHOW_MORE_COUNT_BY_RESULT_TYPE: Record<RESULT_TYPE, number> = {
  [RESULT_TYPE.FILE]: 0,
  [RESULT_TYPE.ORDER]: 0,
  [RESULT_TYPE.SPARE_PART_REQUEST]: 0,
  [RESULT_TYPE.STOCK_ITEM]: 0,
};

export const SEARCH_RESULT_TYPES = [
  RESULT_TYPE.FILE,
  RESULT_TYPE.ORDER,
  RESULT_TYPE.SPARE_PART_REQUEST,
  RESULT_TYPE.STOCK_ITEM,
];
